module.exports = __webpack_public_path__ + "static/7-44c993f087911ce58f732c1fad0f2d5d.jpg";